export function VendorInvoiceAcquisitionCreditCtrl (
  $scope,
  $translate,
  $uibModalInstance,
  currencyApi,
  domainParserApi,
  invoices,
  messages,
  vendorID,
  workshopAPI
) {

  $scope.currency = currencyApi.getInfo();
  $scope.invoices = invoices;

  $scope.selectedInvoices = [];
  $scope.selectedUnits = [];

  // IE specific properties to enable flipper modal compatibility
  $scope.flipped = false;
  $scope.IE      = domainParserApi.isInternetExplorer();

  $scope.invoiceTableSettings = {
    columns: [
      {
        classes: 'text-left',
        field  : 'post_date',
        header : {
          text: $translate.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe: 'globalDate',
      },
      {
        classes: 'text-left',
        field  : 'invoice_status',
        header : {
          text: $translate.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe: 'invoiceStatus',
      },
      {
        classes: 'text-left',
        field  : 'cash_or_account',
        header : {
          text: $translate.instant('GENERAL_SPACE.FIELD.TYPE')
        },
        pipe: 'customerType',
      },
      {
        classes: 'text-right',
        field  : 'total',
        header : {
          classes: 'text-right',
          text   : $translate.instant('GENERAL_SPACE.FIELD.AMOUNT')
        },
        pipe: 'globalCurrency',
      },
      {
        classes: 'text-right',
        field  : 'balance_due',
        header : {
          classes: 'text-right',
          text   : $translate.instant('JS_SPACE.COLUMNS.BALANCE')
        },
        pipe: 'globalCurrency',
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10 ],
      queryCount: () => workshopAPI.get('/vendor_invoices/acquisition_invoices_for_vendor_count')
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: {
      direction: 'desc',
      enabled  : true,
      field    : 'post_date'
    },
  };

  $scope.onInvRowClick = function () {
    $scope.selectedInvoices = $scope.invoices.filter((row) => row.selected);
  };

  $scope.onInvRowDoubleClick = function (event) {
    $scope.selectedInvoices = [event.row];
    $scope.selectInvoice();
  };

  $scope.unitTableSettings = {
    columns: [
      {
        classes: 'text-left',
        field  : 'description',
        header : {
          text: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        },
      },
      {
        classes: 'text-right',
        field  : 'total',
        header : {
          classes: 'text-right',
          text   : $translate.instant('GENERAL_SPACE.FIELD.AMOUNT')
        },
        pipe: 'globalCurrency',
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_UNITS_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  $scope.onUnitRowClick = function () {
    $scope.selectedUnits = $scope.units.filter((row) => row.selected);
  };

  $scope.flipModal = function () {
    $scope.flipped = !$scope.flipped;
    $scope.$emit('flipModal');
  };

  $scope.getInvoices = ( params ) => {
    return workshopAPI.get('/vendor_invoices/acquisition_invoices_for_vendor', [
      vendorID,
      params.offset,
      params.pageSize
    ]).then(invoices => {
      $scope.invoices = invoices;
      return invoices;
    });
  };

  $scope.save = function () {
    $uibModalInstance.close({
      credit_for_acquisition_invoice_id     : $scope.selectedInvoices[0].id,
      credit_for_acquisition_invoice_item_id: $scope.selectedUnits[0].id,
      description                           : $scope.selectedUnits[0].description,
      gst_free                              : $scope.selectedUnits[0].gst_free,
      quantity                              : $scope.selectedUnits[0].quantity,
      unit_cost                             : $scope.selectedUnits[0].unit_cost
    });
  };

  $scope.selectInvoice = function (row) {
    workshopAPI.get('/vendor_invoices/acquisition_items_for_invoice', $scope.selectedInvoices[0].id)
    .then(data => {
      $scope.units = data;
      $scope.flipModal();
    })
    .catch(error => {
      messages.error(error);
    });
  };

  $scope.getInvoices({ offset: 0, pageSize: 5 });
}